export default "__VITE_ASSET__CDCRDAbG__"